// extracted by mini-css-extract-plugin
export default {"root":"MobileFamilyPage__root--3GSu_","content":"MobileFamilyPage__content--3YZOS","title":"MobileFamilyPage__title--2AhU1"};